const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/entitlement/api-factory');
const serviceFactory = require('../resources/entitlement/service-factory');

function parseJson(obj){
  return JSON.stringify(obj);
}

function parseInsightRoles(obj){

  // let oReturn = "";
  // obj.resourceActionModel.map((resource) => {
  //   debugger;
  // });
  // debugger;
  return obj;
}


function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/entitlement/${apiConfig.apiversion}/`,
  });

  const service = serviceFactory({ api });

  return app => app


    .match('[{keys:metaData}].getEntitlementList', requests => Promise.all(
        requests.map(({ req, res }) => 
          service.getUserEntitlementList(req.params.metaData)
            .then(parseJson)
            .then(response => res.value(response))
            .catch(res.error)
      )))

    .match('[{keys:metaData}].getInsightRoles', requests => Promise.all(
        requests.map(({ req, res }) => 
          service.getUserInsightRoles(req.params.metaData)
            .then(response => res.value(response))
            .catch(res.error)
      )))

    .match('[{keys:metaData}].entitlement[{keys:resourceId}].read', requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getUserEntitlement(req.params.resourceId, req.params.metaData)
          .then((hasEntitlement) => res.value(hasEntitlement))
          .catch(res.error))))

    .match('[{keys:metaData}].paymentAvailableCheck', requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getPaymentAvailableCheck(req.params.metaData)
          .then((response) => res.value(response))
          .catch(res.error))))

    .match('[{keys:metaData}].getEntitlementUserPfList[{keys:guidStr}]', requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getEntitlementUserPfList(req.params.metaData)
          .then((response) => res.value(response))
          .catch(res.error))))

    .match(`[{keys:metaData}].getEntitlementsforRM[{keys:inputParam}][{keys:guidStr}]`, requests =>
     Promise.all(
      requests.map(({ req, res }) => 
        service.getEntitlementsforRM(req.params)
          .then(response => res.value(response))
          .catch(res.error)
        )))
}

module.exports = addRoutes;
